import React, {Component} from 'react';
import {Link} from 'react-router';
import Modal from 'react-modal';
import './css/terms.css';

import './css/footer.css';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    width                 : '80%',
    marginRight           : '-20%',
    borderRadius          : '10px',
    overflowX             : 'scroll',
    transform             : 'translate(-50%, -50%)',
    height                : '80%'
  },
  overlay : {
    backgroundColor:'rgba(0, 0, 0, 0.5)'
  }
};

export default class Top extends Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      showTerms: false
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  // モーダルを開く
  openModal() {
    this.setState({modalIsOpen: true});
  }

  // モーダルを閉じる
  closeModal() {
    this.setState({modalIsOpen: false});
  }

  render() {
    return(
            <div className="wrapCover__formBlock-lp-under footer">
              <div className="block_footer-menu"><Link onClick={this.openModal}>利用規約</Link>　|　<a href="mailto:myrate@n-village.co.jp?subject=お問い合わせ">お問い合わせ</a></div>
              <p className="f_copy">Produced by N-village</p>
              <Modal
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="">
                <div className="modal-close" onClick={this.closeModal}></div>
                <div className="modal-content__agreement terms_inner">
                  <h1>利用規約</h1>
                  <div className="terms_body">
                    <p>この利用規約（以下「本規約」といいます。）は、株式会社N-Village（以下「NVC」といいます。）が、個人（以下「お客さま」といいます。）を対象として、お客さまがシェアリングエコノミーサービスなどのウェブサイト上で閲覧できるお客様の評価、ランク、レートなどの情報（以下「レート情報」といいます。）をもとに、NVCが独自に設定する基準に従って、お客さまに対してNVC独自のレートを付与する無償サービス（以下「本サービス」といいます。）の利用に関する条件を、お客さまとNVCとの間で定めるものです。</p>
                    <p className="terms_subtitle">第1条 用語の定義</p>
                    <p>1. 「データプロバイダー」とは、お客さまが本サービスを利用してお客さまご自身のレート情報などを取得できるインターネットサービスのサイトのことをいいます。<br />2.  「データアグリゲーション」 とは、お客さまがNVCを経由して各データプロバイダーにアクセスし、ご自身のレート情報を取得するサービスをいいます。<br />3.  「認証情報」 とは、データプロバイダーにログインする時に必要とされるログイン名とパスワードなどのことをいいます。<br />4.  「本サービスのウェブサイト」とは、https://myrate.jpのことをいいます。</p>
                    <p className="terms_subtitle">第2条 契約の成立</p>
                    <p>1.  NVCは、本規約を定め、この本規約に基づき本サービスを提供します。<br />2.  お客さまは、本サービスに登録した時点で本規約の内容に同意したものとみなされます。<br />3.  お客さまは、本規約を遵守して本サービスを利用するものとします。<br />4.  未成年者であるお客さまが本サービスを利用する場合、親権者など法定代理人の同意が必要です。</p>
                    <p className="terms_subtitle">第3条 サービスの内容</p>
                    <p>1.  NVCに対応しているデータプロバイダーのうち、お客さまが提供した認証情報を利用し、定期的にお客さま指定のデータプロバイダーにログインし、データを取得します。<br />2.  本サービスにおいては、データプロバイダーが提供するサービスを利用することはできません。<br />3.  NVCは、その判断により本サービスの内容、本サービスのウェブサイトまたはソフトウェアの仕様などを予告なく変更することがあります。<br />4.  本サービスのウェブサイトまたは本サービス上に、データプロバイダーなどが使用する商標が表示されることがあります。この商標表示は、これらの商標を有する会社がNVCを推奨もしくは賛同していること、またはこれらの会社がNVCと提携関係にあることを意味しません。</p>
                    <p className="terms_subtitle">第4条 本サービス</p>
                    <p>1.  NVCは、本サービスの信頼性を高めるために最善の努力をしますが、本サービスが提供する情報などの完全性、正確性、確実性、有用性、適時性などについて、以下の各項の場合を含め、一切の責任を負わず、保証も行わないものとします。<br />2.  お客さま提供の認証情報などに誤りがあった場合、正しいパスワードなどが失効する可能性があります。<br />3.  NVCのシステムまたはデータプロバイダーの故障、不具合、一時停止などにより、お客さまにデータを提供できない場合があります。<br />4.  データプロバイダーから取得する情報などがいかなる事情であるかを問わず正しくない場合があります。</p>
                    <p className="terms_subtitle">第5条 個人情報の取扱い</p>
                    <p>1.  NVCは、お客さまの個人情報の取扱いに関しては、本条に定めるところに従い、また、その他については個人情報の保護に関する法律その他関係する法律および規範並びに「野村ホールディングス株式会社　個人情報保護方針」（https://www.nomuraholdings.com/jp/policy/privacy_hd.html）に従い、適切に取り扱うとともに、厳重に管理します。<br />2.  NVCは、お客さまが登録した個人情報を、NVCからの連絡、定期的なレポート、サービス通知、本サービスの改善、新サービスの開発、広告を含む役に立つ情報などの提供の目的でのみ使用します。<br />3.  NVCは、法令に定める場合を除き、事前にお客さまの同意を得ることなくお客さまの個人情報を第三者に提供しません。NVCは、本サービス提供およびこれに付随する業務に必要な範囲で個人情報その他お客様に関する情報の取扱いを業務委託先に委託することができるものとします。</p>
                    <p className="terms_subtitle">第6条 お客さまの権利</p>
                    <p>1.  お客さまは、本サービスを無償でご使用いただけます。ただし、本サービスに関する所有権、知的財産権その他の一切の権利がお客さまに帰属することはありません。<br />2.  お客さまは、いつでもお客さまのアカウントを削除して本サービスを退会することができます。<br />3.  お客さまのアカウントは、お客さまご自身による使用のみのために提供されます。<br />4.  お客さまが有する本サービスにおけるすべての利用権は、第三者に譲渡または貸与することはできません。</p>
                    <p className="terms_subtitle">第7条 お客さまの責任</p>
                    <p>1.  お客さまは、合法的な目的のためにのみ本サービスを利用するものとします。<br />2.  お客さまは、お客さまご自身の意思と責任において本サービスを利用するものとします。<br />3.  お客さまは、本サービスの利用行為および利用行為から生ずる結果について一切の責任を負うものとします。<br />4.  お客さまは、お客さまご本人に関する情報をNVCに対して提供する場合、真実かつ正確な情報を提供するものとします。<br />5.  お客さまは、本サービスをモバイルデバイスで利用される場合は、必ずデバイス上のパスコードを設定し、利用するものとします。<br />6.  お客さまは、本サービスにて提供されるアカウントおよびパスワードを不正に利用されないよう、厳重に管理するものとします。<br />7.  お客さまは、アカウントの不正使用によりNVCまたは第三者に損害を与えることがないように万全の配慮を講じるものとします。<br />8.  NVCは、お客さまが本規約に違反して本サービスを利用していると認めた場合、第9条に定める措置を含む、NVCが必要かつ適切と判断する措置を講じます。ただし、NVCは、お客さまの違反行為を防止または是正する義務を負いません。</p>
                    <p className="terms_subtitle">第8条 禁止事項</p>
                    <p>お客さまは、本サービスの利用にあたり、次の各号の行為を行わないものとします。お客さまが禁止行為に該当する行為を行っているとNVCが判断した場合、NVCは第9条に定める措置を講じます。<br />① 法令もしくは公序良俗に違反する行為、そのおそれのある行為、またはそれに類似する行為。<br />② 当社もしくは第三者の著作権その他の知的財産権を侵害する行為、本サービスの運営もしくは当社の営業を妨害する行為、当社の名誉もしくは信用を毀損する行為、またはそのおそれのある行為。<br />③ リバースエンジニアリングその他の解析行為。<br />④ システムその他の設備に過大な負荷を与える行為。<br />⑤ 他人のIDもしくはパスワードを不正に使用する行為、他人の権利・プライバシーを侵害する行為、他人の営業もしくはサイト運営を妨害する行為、またはそれに類似する行為。<br />⑥ お客さまご自身が有していない、またはお客さまが合法的に利用できないデータプロバイダーのアカウントを本サービスに連携する行為。</p>
                    <p className="terms_subtitle">第9条 提供停止および登録抹消</p>
                    <p>NVCは、お客さまが次の各号のいずれかに該当するときは、本サービスの提供を停止し、または利用登録を抹消することができるものとします。NVCは、本条の規定により本サービスの提供を停止するときは、その理由、提供停止をする日および提供停止期間を、利用登録の抹消をするときは、その理由および利用登録抹消日を、お客さまにあらかじめ通知します。ただし、緊急とNVCが判断した場合は、事後に通知します。<br />① 本規約に違反する行為があったとき<br />② 本サービスの利用に関し、直接または間接にNVCまたは第三者に対し過大な負荷または重大な支障を与えたとき<br />③ NVCにおいて、お客さまの所在が不明となったとき<br />④ 連続して365日以上本サービスの利用がないとき<br />⑤ その他、本サービスの利用が不適切とNVCが判断するとき</p>
                    <p className="terms_subtitle">第10条 サービス停止</p>
                    <p>以下の事由により本サービス提供の制限または停止の必要がある場合、NVCは、その旨事前に通知してお客さまに不都合が生じないように、誠実に最善の努力をします。ただし、緊急とNVCが判断した場合は、事後に通知します。<br />① システム障害の場合<br />② 通信網の障害などの場合<br />③ ソフトウェアまたはハードウェアの故障、不具合または誤作動の場合<br />④ 天災や事変などの非常事態が発生した、または発生するおそれがある場合</p>
                    <p className="terms_subtitle">第11条 サービスの終了</p>
                    <p>1.  NVCは、本サービスの一部または全部を終了する場合は、お客さまに対して通知または告知します。<br />2.  NVCは、本サービスを終了するとき、終了する１か月前までにその旨を通知または告知します。</p>
                    <p className="terms_subtitle">第12条 連絡方法</p>
                    <p>本サービスに関する連絡または通知は、以下のとおりとします。<br />① NVCから連絡する場合は、本サービスのウェブサイト内の適宜の場所への掲示その他のNVCが適当と判断する方法により行います。<br />② お客さまから連絡する場合は、本サービスのウェブサイト内の適宜の場所に設置するお問い合わせフォームの送信またはNVCが指定する方法により行っていただきます。</p>
                    <p className="terms_subtitle">第13条 規約の変更</p>
                    <p>1.  NVCは、本規約を変更することが出来ます。軽微な変更を除き、変更日の１か月前までにその旨を通知または告知を行うものとします。<br />2.  NVCは、軽微な変更を除き、本規約の変更内容と変更理由を、NVCのウェブサイトで発表します。また、特に重要な変更についてはお客さまの登録されているメールアドレスに通知するものとします。<br />3.  通信の事情などにより前項の通知が到達しない場合があっても、変更後の本規約が適用されるものとします。</p>
                    <p className="terms_subtitle">第14条 損害賠償等</p>
                    <p>1.  お客さまが本規約に違反し、NVCに対し損害を与えた場合、お客さまは、NVCに対し、損害賠償義務を負担します。<br />2.  お客さまが本サービスに関して第三者に対して損害を与えた場合または第三者との間で紛争が生じた場合、お客さまの責任と費用にて問題を解決するものとし、NVCは一切の責任を負いません。</p>
                    <p className="terms_subtitle">第15条 免責事項</p>
                    <p>1.  NVCは、本サービスの提供において、システム障害の場合、通信網の障害など第10条に定める場合には責任を負いません。<br />2.  NVCは、本サービスの利用によりお客さまの財産が破損もしくは滅失したことによる損害、または提供された情報などに起因してお客さまに生じた損害について、その原因のいかんによらず、一切の責任を負わないものとします。<br />3.  データプロバイダーにおけるデータアグリゲーションは、お客さまが本サービスを利用することによりお客さまご自身の意思で行う操作であり、NVCは、その行為により生じた結果に対して一切の責任を負わないものとします。<br />4.  NVCは、お客さまに対し、本サービスの全部または一部の提供ができなかったときでも、お客さまに対し、一切の責任を負わないものとします。<br />5.  NVCは、お客さまが本サービスの利用に関して被った一切の損害について、事由のいかんを問わず一切の責任を負わないものとします。</p>
                    <p className="terms_subtitle">第16条 準拠法、裁判管轄</p>
                    <p>本規約は、日本語を正文とし、その準拠法を日本法とします。本規約または本サービスに関するお客さまとNVCとの間の一切の紛争は東京地方裁判所または東京簡易裁判所を第一審の専属管轄裁判所とします。</p>
                    <br />
                    <p>2017年12月27日　制定</p>
                    <p>2018年08月27日　改定</p>
                  </div>
                </div>
              </Modal>
            </div>
    )
	}
}




// WEBPACK FOOTER //
// ./src/footer.js